import React from 'react'

function CategoryAdvert() {
    return (
        <div className="grid-container">
              <div className="grid-item">
                <img
                  src="./images/phones/image 790.png"
                  alt="fun images"
                  className="funImages"
                />
              </div>
              <div className="grid-item">
                <img
                  src="./images/phones/1111.png"
                  alt="fun images"
                  className="funImages"
                />
              </div>
              <div className="grid-item">
                <img
                  src="./images/phones/2924 1 (1).png"
                  alt="fun images"
                  className="funImages"
                />
              </div>
            </div>
    )
}

export default CategoryAdvert
